function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.17804 19.3375L10.6795 1.78336C10.809 1.54627 11 1.34841 11.2323 1.21058C11.4647 1.07274 11.7298 1 12 1C12.2702 1 12.5353 1.07274 12.7677 1.21058C13 1.34841 13.191 1.54627 13.3205 1.78336L22.822 19.3375C22.9445 19.5654 23.0057 19.8213 22.9996 20.0799C22.9935 20.3386 22.9203 20.5913 22.7872 20.8132C22.654 21.035 22.4655 21.2185 22.2402 21.3456C22.0148 21.4728 21.7603 21.5391 21.5015 21.5383H2.49997C2.24109 21.5394 1.98638 21.4732 1.7608 21.3462C1.53522 21.2192 1.34653 21.0357 1.21322 20.8138C1.07992 20.5919 1.00659 20.3391 1.00042 20.0803C0.994255 19.8215 1.05546 19.5655 1.17804 19.3375V19.3375Z",
  stroke: "#EC2B00",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 6.86646V14.2024",
  stroke: "#EC2B00",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 18.6041C12.6078 18.6041 13.1004 18.1114 13.1004 17.5037C13.1004 16.896 12.6078 16.4033 12 16.4033C11.3923 16.4033 10.8997 16.896 10.8997 17.5037C10.8997 18.1114 11.3923 18.6041 12 18.6041Z",
  fill: "#EC2B00"
});

const SvgAlert = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert.39c07df7.svg";
export { ForwardRef as ReactComponent };